// Add feedback to native product forms without replacing the theme's cart flow.
if (!customElements.get('ks-product-card-actions')) {
  customElements.define('ks-product-card-actions', class extends HTMLElement {
    connectedCallback() {
      this.ksAbortController = new AbortController();
      const options = { signal: this.ksAbortController.signal };
      this.addEventListener('submit', (event) => {
        if (event.submitter?.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        this.querySelector('.ks-product-card-error').hidden = true;
        this.querySelector('[data-ks-card-status]').textContent = '';
      }, { ...options, capture: true });

      this.addEventListener('variant:add', (event) => {
        const button = event.target.querySelector('.ks-product-card-action');
        if (!button) return;
        const label = button.getAttribute('aria-label');
        button.dataset.ksCardAdded = '';
        button.disabled = true;
        button.setAttribute('aria-label', this.dataset.ksAddedLabel);
        this.querySelector('[data-ks-card-status]').textContent = this.dataset.ksAddedLabel;
        window.setTimeout(() => {
          delete button.dataset.ksCardAdded;
          button.disabled = false;
          button.setAttribute('aria-label', label);
        }, 650);
      }, options);

      this.addEventListener('cart:error', (event) => {
        const error = this.querySelector('.ks-product-card-error');
        error.textContent = event.detail.error;
        error.hidden = false;
      }, options);
    }

    disconnectedCallback() {
      this.ksAbortController?.abort();
    }
  });
}
